import { useTranslation } from "react-i18next";
import "./ThreeStepGuide.less";

const STEP_KEYS = [
  { number: "01", titleKey: "step1Title" as const, bodyKey: "step1Body" as const, tags: ["map", "routes", "dates"] },
  { number: "02", titleKey: "step2Title" as const, bodyKey: "step2Body" as const, tags: ["chat", "places", "real-time"] },
  { number: "03", titleKey: "step3Title" as const, bodyKey: "step3Body" as const, tags: ["bookings", "locks", "flexibility"] },
];

export function ThreeStepGuide() {
  const { t } = useTranslation("trips");

  return (
    <section className="three-step-guide" data-testid="three-step-guide">
      <p className="three-step-guide__eyebrow">{t("howItWorks.eyebrow")}</p>
      <h2 className="three-step-guide__headline">{t("howItWorks.headline")}</h2>
      <p className="three-step-guide__lede">{t("howItWorks.lede")}</p>
      <div className="three-step-guide__grid">
        {STEP_KEYS.map((s) => (
          <div key={s.number} className="three-step-guide__step">
            <span className="three-step-guide__step-number">
              {s.number} · {t(`howItWorks.${s.titleKey}`)}
            </span>
            <p className="three-step-guide__step-body">{t(`howItWorks.${s.bodyKey}`)}</p>
            <div className="three-step-guide__step-tags">
              {s.tags.map((tag) => (
                <span key={tag} className="three-step-guide__tag">{tag}</span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
